import { CommonModule } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatTableDataSource, MatTableModule } from "@angular/material/table";
import { ILoggedInUser } from "../../interfaces/common/loggedInUser";
import { LoggedInUserService } from "../../services/common/logged-in-user.service";
import { ReactiveFormsModule } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { DistanceService } from "../services/distance.service";
import { DistanceModel, GroupedDistanceModel } from "../models/distance.model";
import { ManageDistanceComponent } from "./manage-distances/manage-distance.component";
import { animate, state, style, transition, trigger } from "@angular/animations";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";

@Component({
  selector: "app-distance-between-locations",
  templateUrl: "./distance-between-locations.component.html",  
  standalone: true,  
  styleUrl: './distance-between-locations.component.scss',
  imports: [CommonModule, MatTableModule, MatProgressSpinnerModule, MatPaginatorModule, ReactiveFormsModule,  MatButtonModule, MatIconModule],
  animations: [
    trigger('detailExpand', [
      state('collapsed,void', style({height: '0px', minHeight: '0'})),
      state('expanded', style({height: '*', paddingBottom: '25px'})),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})

export class DistanceBetweenLocationsComponent implements OnInit {
  isLoading: boolean = false;
  dataSource: MatTableDataSource<GroupedDistanceModel>;
  user: ILoggedInUser;
  isAdmin: boolean = false;
  searchDone: boolean = false;
  innerdisplayedColumns: string[] = ['to', 'distance'];
  columnsToDisplay = ['from'];
  columnsToDisplayWithExpand = [...this.columnsToDisplay];
  expandedElement: GroupedDistanceModel | null;

  constructor(
    private userService: LoggedInUserService,
    private distanceService: DistanceService,    
    private dialog: MatDialog,
  ) {}

  ngOnInit(): void {   
    this.userService.currentUser$.subscribe(data => {
      this.user = data;
      if(this.user != null && this.user.adminRight) {
        this.isAdmin = this.user.adminRight;
        this.getAll();
      }      
    });
    this.dialogClose();
  }

  getAll() {
    if(this.isAdmin){
      this.isLoading = true;
      this.distanceService.getAllDistances()
        .subscribe(data => {
          this.dataSource = new MatTableDataSource<GroupedDistanceModel>(data);
          this.isLoading = false;
          this.searchDone = true;
      });
    }
  } 

  dialogClose(){
    this.dialog.afterAllClosed.subscribe(data => {
      this.getAll();
    });
  }
  
  openDialog(selectedDistance: DistanceModel): void {
    if(this.isAdmin){
      if (selectedDistance) {
        this.dialog.open(ManageDistanceComponent, {
          data: {
            from: selectedDistance.from || "",
            to: selectedDistance.to || "",
            distance: selectedDistance.distance || 0
          }
        });
      }else{
        this.dialog.open(ManageDistanceComponent, {
          data: {
            from: "",
            to: "",
            distance:  0
          }
        });
      }
    }    
  }
}
